import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    welcome: "Hello! I'm your grocery assistant. How can I help you today?",
    inputPlaceholder: "Type your message here...",
    send: "Send",
    listen: "Listening...",
    speak: "Speak",
    clear: "Clear Chat",
    recentMessages: "Recent Messages",
    languageSelector: "Language",
    english: "English",
    arabic: "Arabic",
    hindi: "Hindi",
    malayalam: "Malayalam",
    fullScreen: "Full Screen",
    miniMode: "Mini Mode",
    confirmationPrefix: "I understood that you want to",
    optionsPrefix: "Here are some options:",
    suggestionsPrefix: "You might also be interested in:",
    loading: "Processing your request...",
  },
  ar: {
    welcome: "مرحباً! أنا مساعدك للبقالة. كيف يمكنني مساعدتك اليوم؟",
    inputPlaceholder: "اكتب رسالتك هنا...",
    send: "إرسال",
    listen: "جاري الاستماع...",
    speak: "تحدث",
    clear: "مسح المحادثة",
    recentMessages: "الرسائل الأخيرة",
    languageSelector: "اللغة",
    english: "الإنجليزية",
    arabic: "العربية",
    hindi: "الهندية",
    malayalam: "الماليالامية",
    fullScreen: "ملء الشاشة",
    miniMode: "الوضع المصغر",
    confirmationPrefix: "فهمت أنك تريد",
    optionsPrefix: "فيما يلي بعض الخيارات:",
    suggestionsPrefix: "قد تكون مهتمًا أيضًا بـ:",
    loading: "جاري معالجة طلبك...",
  },
  hi: {
    welcome: "नमस्ते! मैं आपका किराना सहायक हूं। आज मैं आपकी कैसे मदद कर सकता हूं?",
    inputPlaceholder: "अपना संदेश यहां टाइप करें...",
    send: "भेजें",
    listen: "सुन रहा है...",
    speak: "बोलें",
    clear: "चैट साफ़ करें",
    recentMessages: "हाल के संदेश",
    languageSelector: "भाषा",
    english: "अंग्रे़ी",
    arabic: "अरबी",
    hindi: "हिंदी",
    malayalam: "मलयालम",
    fullScreen: "पूर्ण स्क्रीन",
    miniMode: "मिनी मोड",
    confirmationPrefix: "मैंने समझा कि आप चाहते हैं",
    optionsPrefix: "यहां कुछ विकल्प हैं:",
    suggestionsPrefix: "आप इनमें भी रुचि रख सकते हैं:",
    loading: "आपके अनुरोध पर प्रक्रिया हो रही है...",
  },
  ml: {
    welcome: "ഹലോ! ഞാൻ നിങ്ങളുടെ പലചരക്ക് സഹായിയാണ്. ഇന്ന് എങ്ങനെ സഹായിക്കാൻ കഴിയും?",
    inputPlaceholder: "നിങ്ങളുടെ സന്ദേശം ഇവിടെ ടൈപ്പ് ചെയ്യുക...",
    send: "അയയ്ക്കുക",
    listen: "കേൾക്കുന്നു...",
    speak: "സംസാരിക്കുക",
    clear: "ചാറ്റ് മായ്ക്കുക",
    recentMessages: "സമീപകാല സന്ദേശങ്ങൾ",
    languageSelector: "ഭാഷ",
    english: "ഇംഗ്ലീഷ്",
    arabic: "അറബിക്",
    hindi: "ഹിന്ദി",
    malayalam: "മലയാളം",
    fullScreen: "പൂർണ്ണ സ്ക്രീൻ",
    miniMode: "മിനി മോഡ്",
    confirmationPrefix: "നിങ്ങൾ ആഗ്രഹിക്കുന്നത് ഞാൻ മനസ്സിലാക്കി",
    optionsPrefix: "ഇവിടെ ചില ഓപ്ഷനുകളുണ്ട്:",
    suggestionsPrefix: "നിങ്ങൾക്ക് ഇവയിലും താൽപ്പര്യമുണ്ടാകാം:",
    loading: "നിങ്ങളുടെ അഭ്യർത്ഥന പ്രോസസ് ചെയ്യുന്നു...",
  }
};

const LanguageContext = createContext({
  language: 'en',
  setLanguage: () => {},
  t: () => '',
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      <div className={
        (language === 'ar' ? 'lang-ar ' : '') +
        (language === 'hi' ? 'lang-hi ' : '') +
        (language === 'ml' ? 'lang-ml' : '')
      }>
        {children}
      </div>
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext); 